const getTimezone = (offset) => {
  if (offset === "GMT+0000") {
    return "Greenwich Mean Time";
  }
  if (offset === "GMT+0100") {
    return "European Central Time";
  }
  if (offset === "GMT+0200") {
    return "Eastern European Time";
  }
  if (offset === "GMT+0300") {
    return "Eastern European Summer Time";
  }
  if (offset === "GMT+0400") {
    return "Near East Time";
  }
  if (offset === "GMT+0500") {
    return "Pakistan Lahore Time";
  }
  if (offset === "GMT+0600") {
    return "Bangladesh Standard Time";
  }
  if (offset === "GMT+0700") {
    return "Vietnam Standard Time";
  }
  if (offset === "GMT+0800") {
    return "China Taiwan Time";
  }
  if (offset === "GMT+0900") {
    return "Japan Standard Time";
  }
  if (offset === "GMT+1000") {
    return "Australia Eastern Time";
  }
  if (offset === "GMT+1100") {
    return "Solomon Standard Time";
  }
  if (offset === "GMT+1200") {
    return "New Zealand Standard Time";
  }
  if (offset === "GMT-1100") {
    return "Midway Islands Time";
  }
  if (offset === "GMT-1000") {
    return "Hawaii Standard Time";
  }
  if (offset === "GMT-0900") {
    return "Alaska Standard Time";
  }
  if (offset === "GMT-0800") {
    return "Pacific Standard Time";
  }
  if (offset === "GMT-0700") {
    return "Mountain Standard Time";
  }
  if (offset === "GMT-0600") {
    return "Central Standard Time";
  }
  if (offset === "GMT-0500") {
    return "Indiana Eastern Standard Time";
  }
  if (offset === "GMT-0400") {
    return "Puerto Rico and US Virgin Islands Time";
  }
  if (offset === "GMT-0300") {
    return "Argentina Standard Time";
  }
  if (offset === "GMT-0200") {
    return "Mid-Atlantic Standard Time";
  }
  if (offset === "GMT-0100") {
    return "Central African Time";
  }
  return "Greenwich Mean Time";
};
export default getTimezone;
